<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { POST_FIELDS, DATE_PORTION } from '@/services/charts-service';
import sentimentModel from '@/mixins/sentiment-model';

export default {
  name: 'BrandHealthSimpleData',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    sentimentModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '0',
      rawVariation: '0',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      this.getChartsService({
        itemId: this.itemId,
        method: 'getTimeSeries',
        params: {
          datePortion: DATE_PORTION.BY_YEAR,
          grouping: [POST_FIELDS.POLARITY],
        },
      })
        .then(response => {
          const normalizedResponse = this.normalizeSentimentResponseFromChartService(response);
          const totalPosts = normalizedResponse.points.map(res => res.data[0]).reduce((sum, value) => {
            return sum + value;
          });
          const percentPos = (normalizedResponse.points[0].data[0] / totalPosts) * 100;
          const percentNeu = (normalizedResponse.points[1].data[0] / totalPosts) * 100;

          this.variation = '0';
          this.rawVariation = '0';
          this.value = `${(percentPos + percentNeu).toFixed(0)}%`;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
